import { Route } from 'react-router-dom';

import { SectionLayout } from 'shared/ui/layout';
import { ADD_PREFIX } from 'shared/consts/routes/common';
import {
  CAR_BRAND,
  CAR_BRANDS,
  CAR_BRAND_ROUTES,
  CAR_MODEL,
  CAR_MODELS,
} from 'shared/consts/routes/car-brands';

import { Controller, RequireAuth, Right } from 'entities/authorization';
import { CarBrandLayout } from 'entities/car-brand-layout';
import { CarModelsLayout } from 'entities/car-models-layout';

import { ConnectedCarModelsTable } from 'features/car-model/table';
import { EditCarBrand } from 'features/car/edit-car-brand';
import { ConnectedCarModelsMenu } from 'features/car/menu';

import { AddCarBrandPage, EditCarBrandPage } from 'pages/car-brand';
import { AddCarModelPage, EditCarModelPage } from 'pages/car-model';
import { CarBrandModelsListPage } from 'pages/car-brand/car-models-list';

const withRequireAuth = (
  route: JSX.Element,
  controller: Controller,
  right: Right
) => {
  return (
    <Route
      element={<RequireAuth controllerName={controller} rightType={right} />}
    >
      {route}
    </Route>
  );
};

export const CarModelRoutes = (
  <Route element={<RequireAuth controllerName="Car" rightType="Read" />}>
    <Route
      path={CAR_BRANDS}
      element={<SectionLayout menu={<ConnectedCarModelsMenu />} />}
    >
      <Route element={<CarModelsLayout />}>
        <Route index element={<ConnectedCarModelsTable />} />
      </Route>

      {withRequireAuth(
        <Route
          path={CAR_BRAND_ROUTES.ADD_CAR_BRAND}
          element={<AddCarBrandPage />}
        />,
        'Car',
        'Write'
      )}

      {withRequireAuth(
        <Route
          path={CAR_BRAND_ROUTES.ADD_CAR_MODEL}
          element={<AddCarModelPage />}
        />,
        'Car',
        'Write'
      )}

      <Route path={CAR_BRAND} element={<CarBrandLayout />}>
        <Route index element={<EditCarBrand />} />
        <Route path={CAR_MODELS} element={<CarBrandModelsListPage />} />
      </Route>

      <Route
        path={`${CAR_BRAND}/${CAR_MODEL}`}
        element={<EditCarModelPage />}
      />
    </Route>
  </Route>
);
